import React from 'react';
import { Grid, IconButton, Typography } from "@mui/material";
import { Box, useTheme } from "@mui/system";
import { Link as RouterLink } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import useMediaQuery from '@mui/material/useMediaQuery';
import { CustomLink } from './CustomLink';

interface NavBarProps {
    hideLinks?: boolean;
}

export function NavBar({ hideLinks }: NavBarProps) {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));

    return (
        <Box component="nav" style={{ width: '100%' }} marginBottom={{ xs: "24px", sm: "64px" }}>
            <Grid item xs={12} justifyContent="space-between" display="flex" height={72} alignItems="center">
                <RouterLink to="/" style={{ textDecoration: 'none' }}>
                    <Typography
                        sx={{
                            fontWeight: 700,
                            fontSize: '1.25rem',
                            color: '#1e293b',
                            letterSpacing: '-0.02em',
                            '&:hover': { color: '#2563eb' },
                            transition: 'color 0.2s ease',
                        }}
                    >
                        Damon Ye
                    </Typography>
                </RouterLink>

                {!hideLinks && <Box>
                    {!matches && (
                        <RouterLink to="/nav">
                            <IconButton sx={{ '&:hover': { backgroundColor: 'rgba(37, 99, 235, 0.08)' } }}>
                                <MenuIcon sx={{ color: '#1e293b' }} />
                            </IconButton>
                        </RouterLink>
                    )}
                    {matches && (
                        <Box sx={{ display: 'flex', gap: '4px' }}>
                            <CustomLink to="/">About</CustomLink>
                            <CustomLink to="/uses">Uses</CustomLink>
                        </Box>
                    )}
                </Box>}
            </Grid>
        </Box>
    );
}
